// html2pdf.component.ts
import { Component, Renderer2, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/compat/storage';
import { AppFirestoreService } from 'src/app/_services/app-firestore.service';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-html2pdf',
  templateUrl: './html2pdf.component.html',
  styleUrls: ['./html2pdf.component.css']
})
export class Html2pdfComponent {
  private offerElement: HTMLElement;
  @Input() companyId: string = "0";
  @Input() section: string = "ffffffffffffffffffffffffffffff";
  @Input() galleryId: string = "0";
  @Output()  
  blob: any = new EventEmitter();
  task: AngularFireUploadTask;
  filesBaseUrl = `https://firebasestorage.googleapis.com/v0/b/${environment.firebase.storageBucket}/o/`;
  // Progress monitoring
  percentage: Observable<number>;

  snapshot: Observable<any>;

  // Download URL
  downloadURL: Observable<string>;
 
  constructor(private renderer: Renderer2, private el: ElementRef,private storage: AngularFireStorage,
    private db: AppFirestoreService,) {}

  public captureScreen() {

    const offerElement = this.renderer.selectRootElement('#preview-container', true);
    const hideUserForm = this.renderer.selectRootElement('app-price-calculator-housing', true);
    this.renderer.addClass(offerElement, 'save-pdf');
    if (offerElement) {
      const options = {
        scale: 1,  // Keep a higher resolution
        useCORS: true,
        logging: true,
        allowTaint: false,
        scrollX: 0,
        scrollY: -window.scrollY
      };
  
      html2canvas(offerElement, options).then(originalCanvas => {
        const pdf = new jsPDF('p', 'mm', 'a4');
        // const imgWidth = 190;  // Adjusted for page margin
        const imgWidth = 190;  // Adjusted for page margin
        const scaledPageHeight = originalCanvas.height * (imgWidth / originalCanvas.width);
        // const pageHeight = 280;  // Adjusted for page margin
        const pageHeight = 290;  // Adjusted for page margin
  
        let remainingHeight = scaledPageHeight;
        let pageOffset = 0;
  
        while (remainingHeight > 0) {
          if (pageOffset !== 0) {
            pdf.addPage();
          }
  
          // Create a new canvas element to draw the sliced section
          const sliceCanvas = document.createElement('canvas');
          sliceCanvas.width = originalCanvas.width;
          sliceCanvas.height = Math.min(originalCanvas.height, originalCanvas.height * (pageHeight / scaledPageHeight));
  
          const sliceCtx = sliceCanvas.getContext('2d');
          sliceCtx.drawImage(originalCanvas, 0, -pageOffset * (originalCanvas.height / scaledPageHeight));
  
          // Convert the sliced section to a data URL and add it to the PDF
          const sliceDataUrl = sliceCanvas.toDataURL('image/png');
          pdf.addImage(sliceDataUrl, 'PNG', 10, 0, imgWidth, pageHeight);

          // const sliceDataUrl = sliceCanvas.toDataURL('image/jpeg', 0.5);  // Use JPEG and reduce quality to 50%
          // pdf.addImage(sliceDataUrl, 'JPEG', 10, 0, imgWidth, pageHeight);
  
          remainingHeight -= pageHeight;
          pageOffset += pageHeight;
        }
        const pdfBlob = pdf.output('blob'); // This is synchronous
        this.blob.emit(pdfBlob)
        // this.uploadFile(pdfBlob);
        pdf.save('download.pdf');
      });
    }

    


  }
  
  
  uploadFile(file: any) {

    file.name = 'offer';
    // The storage path
    const path = `${this.companyId}/${this.section}/${new Date().getTime()}_${file.name}`;

    // Totally optional metadata
    const customMetadata = { title: file.name };

    const fileRef = this.storage.ref(path);
    // The main task
    this.task = this.storage.upload(path, file, { customMetadata });

    // Progress monitoring
    this.percentage = this.task.percentageChanges();
    this.snapshot = this.task.snapshotChanges();
    // The file's download URL 
    this.task.snapshotChanges().pipe(
      finalize(() => {
        this.downloadURL = fileRef.getDownloadURL();

        // let id = randomString(20);
        let type = 'pdf';

        const itm = { section: this.section, galleryId: this.galleryId, path, size: file.size, type: type };
        console.log(this.filesBaseUrl + encodeURIComponent(path) + '?alt=media');
        this.db.collection('galleries').doc(this.companyId).collection(this.section).add(itm);
        // this.offer.flatsArray.push(this.currentFlat);
      })
    )
      .subscribe();
  }
  
  
  
  
  
}
